module.exports = function () {
    const stripSearchQuery = (e) => {
        e.preventDefault();
        const searchForm = e.target;
        const searchInput = searchForm.querySelector(".generic-search-bar__input");
        const searchUrlBase = searchForm.getAttribute("action");
        const queryParam = searchInput.name;
        const query = searchInput.value;
        const strippedQuery = query.replace(/[^\w\s]/g, "");
        const searchUrl = `${searchUrlBase}?${queryParam}=${strippedQuery}`;
        window.location.href = searchUrl;
    };

    document
        .querySelector(".generic-search-bar__form")
        .addEventListener("submit", stripSearchQuery);
};